var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadSolid = function SvgDownloadSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6h-4V0H4v6H0l7 7zM0 15v2h14v-2z"
  })));
};
export default SvgDownloadSolid;